/* eslint-disable no-unused-vars */
import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useContext,
  useCallback,
} from "react";
import classnames from "classnames";
import { useLocation } from "react-router-dom";
import classes from "./CalendarWeekView.module.css";
import {
  calendarToEpochDays,
  useCalendarDateUrl,
  useReftchRefProvider,
  weekDayTranslation,
  AgendaSelectedUserContext,
  useAgendaNotesDateUrl,
  useOutlookEventsDateUrl,
  useTarefasDateUrl,
  outlookMutateBeforeNormalization,
} from "../../CalendarHelper";
import { FormattedMessage } from "react-intl";
import { many } from "../../../../Helpers/SchemaHelper";
import { useToast } from "../../../Toast/ToastProvider";
import {
  useQuery,
  useSpaceQuery,
  useSpacePost,
  getEntity,
} from "../../../../Helpers/IOClient";
import { useMultipleEntityValueSelector } from "../../../../Hooks/AdvancedEntityHooks";
import { getResolvedSizes, getSize } from "./CalendarWeekViewHelper";
import { useHoverEvents } from "../../../../Containers/Origin/Origin";
import Popup from "../../../Popup/Popup";
import {
  buildItems,
  buildResolvedValueItem,
  sortRowItems,
} from "../CalendarMonthView/CalendarMonthView";
import { useEntitySummarySidebar } from "../../../EntitySummaries/EntitySummariesHelper";
import { BarLoader } from "../../../GlobalLoader/GlobalLoader";
import { ColorFilterBars } from "../../../FilterList/AdvancedFilter/AdvancedFilterColors/AdvancedFilterColors";
import moment from "moment";
import {
  SidebarViewSetterContext,
  SidebarViewContext,
} from "../../../Sidebar/SidebarViewsHelper";
import { useSpace } from "../../../../Contexts/SpaceContext";
import {
  spaceAgendaSchema,
  spaceInterventionsSchema,
  spaceOutlookEventsSchema,
  spaceTasksSchema,
} from "../../../../config/schema";
import { useAgenda } from "../../../../Hooks/EntityHooks";
import { moduleTypes } from "../../../../Helpers/ModulesHelper";
import {
  formatInterventionForm,
  formatTaskForm,
  getInterventionTarget,
} from "../../../../Helpers/FormFormmaterHelper";
import {
  MilSecToFormatedHourMinute,
  MilSecToMinute,
} from "../../../../Helpers/MiscHelper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAgendaPreferences } from "../../../AgendaPreferences/AgendaPreferences";
import { faClock } from "@fortawesome/pro-light-svg-icons";
import { useCanCreateProvider } from "../../OtherCalendarHelper";
import { useCurrentAccount } from "../../../../Contexts/UserContext";
import InformationComponent from "../../../InformationComponent/InformationComponent";
import dayjs from "dayjs";

const getTotalPause = (
  personalPreferences,
  _newBegin,
  _newEnd,
  defaultValue = 0,
) => {
  let TotalPauses = defaultValue;
  const newBegin = moment(_newBegin);
  const newEnd = moment(_newEnd);
  if (personalPreferences) {
    const weekDay = newBegin.day();
    const { lunchBegin, lunchEnd, enabled } =
      personalPreferences?.workschedule[weekDay] || {};

    if (enabled && lunchBegin && lunchEnd) {
      const lunchBeginDate = moment(newBegin).set({
        hour: parseInt(lunchBegin.split(":")[0], 10),
        minute: parseInt(lunchBegin.split(":")[1], 10),
      });
      const lunchEndDate = moment(newBegin).set({
        hour: parseInt(lunchEnd.split(":")[0], 10),
        minute: parseInt(lunchEnd.split(":")[1], 10),
      });

      if (
        moment(newBegin).isBefore(lunchBeginDate) &&
        moment(newEnd).isAfter(lunchEndDate)
      ) {
        TotalPauses = lunchEndDate.diff(lunchBeginDate, "milliseconds");
      } else if (
        moment(newBegin).isBetween(
          lunchBeginDate,
          lunchEndDate,
          undefined,
          "[)",
        ) &&
        moment(newEnd).isAfter(lunchEndDate)
      ) {
        TotalPauses = lunchEndDate.diff(moment(newBegin), "milliseconds");
      } else if (
        moment(newBegin).isBefore(lunchBeginDate) &&
        moment(newEnd).isBetween(lunchBeginDate, lunchEndDate, undefined, "(]")
      ) {
        TotalPauses = moment(newEnd).diff(lunchBeginDate, "milliseconds");
      } else {
        TotalPauses = 0;
      }
    }
  }
  return TotalPauses;
};

export const WeeklyHeaderDay = ({
  forcedTime,
  time,
  i,
  holidayData,
  outOfGridItems,
  items,
}) => {
  const personalPreferences = useAgendaPreferences();

  const { dayOfMonth, isHoliday, isCurrentDay, IsWeekend, forcedDay } =
    useMemo(() => {
      const d = forcedTime ? new Date(forcedTime) : addDays(time, i);
      let isHoliday = false;
      let IsWeekend = false;
      const currentDate = new Date();
      const isCurrentDay = currentDate.toDateString() === d.toDateString();
      let fday = d.getDay();
      if (Array.isArray(holidayData)) {
        const resolvedPersonalPreferences = personalPreferences || {};
        const momentDate = moment(d);
        const resolvedString = momentDate.format("YYYY-MM-DD");
        const weekDay = momentDate.day();

        const dayObj =
          holidayData.find((h) => {
            const key = h?.DateKey || "";
            return key === resolvedString;
          }) || {};
        isHoliday = dayObj.IsHoliday;
        IsWeekend = dayObj.IsWeekend;

        //override if weekend and personal preferences say working day
        if (Array.isArray(resolvedPersonalPreferences.workschedule)) {
          IsWeekend =
            !resolvedPersonalPreferences.workschedule[weekDay]?.enabled;
        }
      }

      return {
        dayOfMonth: d.getDate(),
        isHoliday,
        IsWeekend,
        isCurrentDay,
        forcedDay: i !== fday ? fday : undefined,
      };
    }, [forcedTime, time, i, holidayData, personalPreferences]);

  const total = useMemo(() => {
    let t = 0;
    if (Array.isArray(items)) {
      for (const e of items) {
        const { metadata } = e;
        if (metadata?.EstimatedCost && !metadata?.IsTask) {
          t += metadata.EstimatedCost || 0;
        }
        // else if (metadata?.Duration) {
        //   t += metadata.Duration || 0;
        // }
      }
    }
    // if (Array.isArray(outOfGridItems) && outOfGridItems.length > 0) {
    //   const startCurrentDay = new Date(
    //     forcedTime ? forcedTime : time + dayMilsec * i,
    //   );
    //   startCurrentDay.setHours(0, 0, 0, 0);
    //   const endCurrentDay = new Date(
    //     forcedTime ? forcedTime : time + dayMilsec * i,
    //   );
    //   endCurrentDay.setHours(23, 59, 59);
    //   const dj = dayjs(startCurrentDay);
    //   const de = dayjs(startCurrentDay).add(1, "day");
    //   for (const e of outOfGridItems) {
    //     const { metadata, BeginDate: MetaBeginDate, EndDate: MetaEndDate } = e;
    //     const djs = dayjs(MetaBeginDate);
    //     const dje = dayjs(MetaEndDate);
    //     if (dj.isBetween(djs, dje, "day", "()")) {
    //       t += dayMilsec;
    //     } else if (dj.isSame(djs, "day") && dj.isBefore(dje, "day")) {
    //       const dif = de.diff(djs, "milliseconds");
    //       if (dif === dayMilsec - 5000) t += dayMilsec;
    //       else t += dif;
    //     } else if (dj.isSame(dje, "day") && dj.isAfter(djs, "day")) {
    //       const diff = dje.diff(dj, "milliseconds");
    //       if (diff === dayMilsec - 60000) t += dayMilsec;
    //       else t += diff;
    //     }
    //   }
    // }
    if (t === 0) return null;

    return [`${MilSecToFormatedHourMinute(t)}`, MilSecToMinute(t)];
  }, [items]);

  const location = useLocation();

  const isOnAgenda = useMemo(() => {
    return (
      location.pathname.includes("calendar") ||
      location.pathname.includes("timemanager")
    );
  }, [location.pathname]);

  return (
    <div
      className={classnames(
        "d-flex justify-content-center text-black text-uppercase fs-14",
        classes.headerDay,
        { [classes.selected]: isCurrentDay },
        isOnAgenda && isHoliday ? classes.holidayItemBackground : "",
        isOnAgenda && IsWeekend ? classes.weekendItemBackground : "",
      )}
    >
      <div className="d-flex  align-items-center overflow-hidden gap-1 w-full px-1">
        <span style={{ maxWidth: 115 }} className="text-truncate fw-medium">
          <FormattedMessage id={weekDayTranslation[forcedDay || i]} />
        </span>
        <span className="fw-medium h-fit">{dayOfMonth}</span>
        {total ? (
          <InformationComponent
            placement="top"
            text={total[1] > 0 ? `${total[1]} min` : undefined}
          >
            <span className="d-flex h-fit ml-3 fs-12 fw-medium flex-0-0-auto align-items-center">
              <FontAwesomeIcon size="xs" icon={faClock} />
              <span className="ml-1">{total[0]}</span>
            </span>
          </InformationComponent>
        ) : null}
      </div>
    </div>
  );
};
const dayMilsec = 86400000;
// calendar-day add; ms math (i * dayMilsec) drifts an hour across DST changes
const addDays = (time, n) => {
  const d = new Date(time);
  d.setDate(d.getDate() + n);
  return d;
};

const WeekDayHeader = React.memo(function WeekDayHeader({
  startMil,
  items,
  workWeek,
  multipleDay,
  holidayData,
}) {
  const agendaPreferences = useAgendaPreferences();

  if (workWeek) {
    const workSchedule = agendaPreferences?.workschedule || [];

    const workingDaysIndexes = workSchedule.filter((day) => day.enabled);

    if (workingDaysIndexes.length > 0)
      return (
        <div
          style={{ position: "sticky", top: "48px", zIndex: "6" }}
          className={classnames("d-flex border-top", classes.headerContainer)}
        >
          <div className={classnames("d-flex flex-1")}>
            {workingDaysIndexes.map((item) => (
              <WeeklyHeaderDay
                key={`workweek-header-${item.day}`}
                holidayData={holidayData}
                i={item.day}
                items={
                  items?.gridItems ? items?.gridItems[item.day] : undefined
                }
                outOfGridItems={items?.outOfGridItems}
                time={startMil}
              />
            ))}
          </div>
          <div className={classes.fakeScroll} />
        </div>
      );
  }

  if (multipleDay && items?.gridItems) {
    let startDate = new Date(startMil);
    const resolvedItems = [];
    for (const key in items.gridItems) {
      if (!Object.prototype.hasOwnProperty.call(items.gridItems, key)) continue;
      const index = parseInt(key, 10);
      const current = moment(startDate).add(index, "days");
      const dayofWeek = current.day();
      const resovledDayItems = items.gridItems[key] || undefined;
      resolvedItems.push(
        <WeeklyHeaderDay
          key={`day-header-${key}`}
          holidayData={holidayData}
          forcedTime={current.toDate()}
          i={dayofWeek}
          outOfGridItems={items?.outOfGridItems}
          items={resovledDayItems}
          time={startMil}
        />,
      );
    }

    return (
      <div
        className={classnames("d-flex border-top", classes.headerContainer)}
        style={{ position: "sticky", top: "48px", zIndex: "6" }}
      >
        <div className={classnames("d-flex flex-1")}>{resolvedItems}</div>
        <div className={classes.fakeScroll} />
      </div>
    );
  }

  return (
    <div
      className={classnames("d-flex border-top", classes.headerContainer)}
      style={{ position: "sticky", top: "48px", zIndex: "6" }}
    >
      <div className={classnames("d-flex flex-1")}>
        <WeeklyHeaderDay
          holidayData={holidayData}
          i={0}
          items={items?.gridItems ? items?.gridItems[0] : undefined}
          outOfGridItems={items?.outOfGridItems}
          time={startMil}
        />
        <WeeklyHeaderDay
          holidayData={holidayData}
          i={1}
          items={items?.gridItems ? items?.gridItems[1] : undefined}
          outOfGridItems={items?.outOfGridItems}
          time={startMil}
        />
        <WeeklyHeaderDay
          holidayData={holidayData}
          i={2}
          items={items?.gridItems ? items?.gridItems[2] : undefined}
          outOfGridItems={items?.outOfGridItems}
          time={startMil}
        />
        <WeeklyHeaderDay
          holidayData={holidayData}
          i={3}
          items={items?.gridItems ? items?.gridItems[3] : undefined}
          outOfGridItems={items?.outOfGridItems}
          time={startMil}
        />
        <WeeklyHeaderDay
          holidayData={holidayData}
          i={4}
          items={items?.gridItems ? items?.gridItems[4] : undefined}
          outOfGridItems={items?.outOfGridItems}
          time={startMil}
        />
        <WeeklyHeaderDay
          holidayData={holidayData}
          i={5}
          items={items?.gridItems ? items?.gridItems[5] : undefined}
          outOfGridItems={items?.outOfGridItems}
          time={startMil}
        />
        <WeeklyHeaderDay
          holidayData={holidayData}
          i={6}
          items={items?.gridItems ? items?.gridItems[6] : undefined}
          outOfGridItems={items?.outOfGridItems}
          time={startMil}
        />
      </div>
      <div className={classes.fakeScroll} />
    </div>
  );
});

const getAllWeekDays = (year, month, day) => {
  const date = new Date(year, month, day);
  const end = 6 - date.getDay();
  const start = date.getDay();
  const endDate = new Date(year, month, day + end);

  const startDate = new Date(year, month, day - start, 18);

  return { startDate, endDate, month, startDateMil: startDate.getTime() };
};

const getMultipleDays = (year, month, day) => {
  const date = new Date(year, month, day);
  const end = moment(date).add(3, "days");
  const start = moment(date).subtract(3, "days");

  const startDate = start.toDate();

  return {
    startDate,
    endDate: end.toDate(),
    month,
    startDateMil: startDate.getTime(),
  };
};

window.getAllWeekDays = getAllWeekDays;

const HourItem = ({ hour }) => {
  return (
    <div
      id={hour}
      className={classnames(
        "p-1 d-flex justify-content-center fs-14",
        classes.hourItem,
      )}
    >
      {hour}
    </div>
  );
};

export const CalendarHourList = ({ loading, outofBoundItems }) => {
  const timeoutRef = useRef();

  useEffect(() => {
    if (loading) return;
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (!outofBoundItems || outofBoundItems === 0) {
      timeoutRef.current = setTimeout(() => {
        const cont = document.getElementById(
          "calendar-container-one",
        ).parentNode;
        if (cont)
          cont.scrollTo({
            top: document.getElementById("08:00").offsetTop - 45,
            behavior: "smooth",
          });
      }, 100);
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [loading, outofBoundItems]);

  return (
    <>
      <div className={classes.hourList}>
        <HourItem hour="00:00" />
        <HourItem hour="01:00" />
        <HourItem hour="02:00" />
        <HourItem hour="03:00" />
        <HourItem hour="04:00" />
        <HourItem hour="05:00" />
        <HourItem hour="06:00" />
        <HourItem hour="07:00" />
        <HourItem hour="08:00" />
        <HourItem hour="09:00" />
        <HourItem hour="10:00" />
        <HourItem hour="11:00" />
        <HourItem hour="12:00" />
        <HourItem hour="13:00" />
        <HourItem hour="14:00" />
        <HourItem hour="15:00" />
        <HourItem hour="16:00" />
        <HourItem hour="17:00" />
        <HourItem hour="18:00" />
        <HourItem hour="19:00" />
        <HourItem hour="20:00" />
        <HourItem hour="21:00" />
        <HourItem hour="22:00" />
        <HourItem hour="23:00" />
      </div>
    </>
  );
};

// const DayItem

const ContentPlaceholderGridItem = ({
  selected,
  onMouseUp,
  onMouseDown,
  isHoliday,
  isWeekend,
  setSelectedDate,
  gridDate,
  blockid,
  schema,
  currentSelectedDate,
  onMouseEnter,
}) => {
  const [_, setIsLoading] = useContext(UpdatingItemsContext);
  const refetchRef = useReftchRefProvider();
  const personalPreferences = useAgendaPreferences();
  const selectedUser = useContext(AgendaSelectedUserContext);

  const createInterventionUpdateForm = useCallback(
    ({ Id, BeginDate, EndDate, TotalPauses }) => {
      const schemaItem = getEntity(spaceInterventionsSchema, Id);
      const formattedForm = {
        Id,
        BeginDate,
        EndDate,
        TotalPauses,
      };

      return formattedForm;
    },
    [],
  );

  const createTaskUpdateForm = useCallback(({ Id, BeginDate, EndDate }) => {
    const schemaItem = getEntity(spaceTasksSchema, Id);
    const formattedForm = {
      Id,
      BeginDate,
      EndDate,
    };

    return formattedForm;
  }, []);

  const location = useLocation();

  const isOnAgenda = useMemo(() => {
    return (
      location.pathname.includes("calendar") ||
      location.pathname.includes("timemanager")
    );
  }, [location.pathname]);

  const isOutsideWorkHours = useMemo(() => {
    if (
      !personalPreferences ||
      !Array.isArray(personalPreferences.workschedule)
    )
      return isWeekend || isHoliday || blockid < 510 || blockid > 1095;
    else {
      const weekDayMoment = moment(gridDate);
      weekDayMoment.set("hours", 0);
      weekDayMoment.set("minutes", 0);
      weekDayMoment.add(parseInt(blockid), "minutes");
      const weekDay = weekDayMoment.day();
      const dayPref = personalPreferences.workschedule[weekDay];
      if (!dayPref || !dayPref.enabled) return true;
      const beginDate = moment(weekDayMoment).set({
        hour: parseInt(dayPref.workBegin.split(":")[0], 10),
        minute: parseInt(dayPref.workBegin.split(":")[1], 10),
      });
      const endDate = moment(weekDayMoment).set({
        hour: parseInt(dayPref.workEnd.split(":")[0], 10),
        minute: parseInt(dayPref.workEnd.split(":")[1], 10),
      });
      const lunchStartDate = moment(weekDayMoment).set({
        hour: parseInt(dayPref.lunchBegin.split(":")[0], 10),
        minute: parseInt(dayPref.lunchBegin.split(":")[1], 10),
      });
      const lunchEndDate = moment(weekDayMoment).set({
        hour: parseInt(dayPref.lunchEnd.split(":")[0], 10),
        minute: parseInt(dayPref.lunchEnd.split(":")[1], 10),
      });

      return !(
        weekDayMoment.isBetween(beginDate, endDate, undefined, "[)") &&
        !weekDayMoment.isBetween(lunchStartDate, lunchEndDate, undefined, "[)")
      );
    }
  }, [blockid, gridDate, isHoliday, isWeekend, personalPreferences]);

  const [post] = useSpacePost(`calendars/${selectedUser}/Update`, schema, {
    onSuccess: () => {
      setIsLoading(false);
    },
    onError: () => {
      setIsLoading(false);
    },
  });

  const [createPost] = useSpacePost(
    `calendars/${selectedUser}`,
    spaceAgendaSchema,
    {
      onSuccess: () => {
        setIsLoading(false);
        if (refetchRef?.current) refetchRef.current();
      },
      onError: () => {
        setIsLoading(false);
      },
    },
  );

  const [createInterventionFromDuplicate] = useSpacePost(
    "interventions",
    spaceInterventionsSchema,
    {
      onSuccess: () => {
        setIsLoading(false);
        if (refetchRef?.current) refetchRef.current();
        window.TempBeginDate = undefined;
        window.TempEndDate = undefined;
      },
      onError: (error) => {
        setIsLoading(false);
        window.TempBeginDate = undefined;
        window.TempEndDate = undefined;
      },
    },
  );

  const [createTaskFromDuplicate] = useSpacePost("tasks", spaceTasksSchema, {
    onSuccess: () => {
      setIsLoading(false);
      if (refetchRef?.current) refetchRef.current();
      window.TempBeginDate = undefined;
      window.TempEndDate = undefined;
    },
    onError: (error) => {
      setIsLoading(false);
      window.TempBeginDate = undefined;
      window.TempEndDate = undefined;
    },
  });

  const [postIntervention] = useSpacePost(
    `Calendars/${selectedUser}/Interventions/Update`,
    spaceInterventionsSchema,
    {
      onSuccess: () => {
        setIsLoading(false);
        if (refetchRef?.current) refetchRef.current();
      },
      onError: () => {
        setIsLoading(false);
      },
    },
  );

  const [postTask] = useSpacePost(
    `Calendars/${selectedUser}/ProjectTasks/Update`,
    spaceTasksSchema,
    {
      onSuccess: () => {
        setIsLoading(false);
        if (refetchRef?.current) refetchRef.current();
      },
      onError: () => {
        setIsLoading(false);
      },
    },
  );

  const handleSubmitDuplicateIntervention = useCallback(
    (data) => {
      const item = getEntity(spaceInterventionsSchema, data);
      const InterventionTarget = getInterventionTarget(item);

      const { DevOps } = item;
      const devOpsObj = {};

      if (DevOps) {
        if (DevOps?.Collection) {
          devOpsObj.DevOpsCollection = DevOps.Collection;
        }
        if (DevOps?.Project) {
          devOpsObj.DevOpsProject = DevOps.Project;
        }
        if (DevOps?.Repository) {
          devOpsObj.DevOpsRepository = DevOps.Repository;
        }
        if (DevOps?.Commit) {
          devOpsObj.DevOpsCommit = DevOps.Commit;
        }
        if (DevOps?.WorkItem) {
          devOpsObj.DevOpsWorkItem = DevOps.WorkItem;
        }
      }

      const formattedForm = formatInterventionForm({
        ...item,
        BeginDate: window.TempBeginDate || item.BeginDate,
        EndDate: window.TempEndDate || item.EndDate,
        InterventionTarget,
        TotalPauses: getTotalPause(
          personalPreferences,
          window.TempBeginDate || item.BeginDate,
          window.TempEndDate || item.EndDate,
          item.TotalPauses,
        ),
        ...devOpsObj,
      });

      createInterventionFromDuplicate(formattedForm);
    },
    [createInterventionFromDuplicate, personalPreferences],
  );

  const handleSubmitDuplicateTask = useCallback(
    (data) => {
      const item = getEntity(spaceTasksSchema, data);
      const TaskTarget = getInterventionTarget(item);
      const { DevOps } = item;
      const devOpsObj = {};

      if (DevOps) {
        if (DevOps?.Collection) {
          devOpsObj.DevOpsCollection = DevOps.Collection;
        }
        if (DevOps?.Project) {
          devOpsObj.DevOpsProject = DevOps.Project;
        }
        if (DevOps?.Repository) {
          devOpsObj.DevOpsRepository = DevOps.Repository;
        }
      }
      const formattedForm = formatTaskForm({
        ...item,
        BeginDate: window.TempBeginDate || item.BeginDate,
        EndDate: window.TempEndDate || item.EndDate,
        TaskTarget,
        ...devOpsObj,
      });

      createTaskFromDuplicate(formattedForm);
    },
    [createTaskFromDuplicate],
  );

  const [duplicateTask] = useSpacePost(
    `Calendars/${selectedUser}/ProjectTasks/Details`,
    spaceTasksSchema,
    {
      onSuccess: (e) => {
        handleSubmitDuplicateTask(e.data);
      },
      onError: () => {
        setIsLoading(false);
        window.TempBeginDate = undefined;
        window.TempEndDate = undefined;
      },
    },
  );

  const [duplicateIntervention] = useSpacePost(
    `Calendars/${selectedUser}/Interventions/Details`,
    spaceInterventionsSchema,
    {
      onSuccess: (e) => {
        handleSubmitDuplicateIntervention(e.data);
      },
      onError: () => {
        setIsLoading(false);
        window.TempBeginDate = undefined;
        window.TempEndDate = undefined;
      },
    },
  );

  const onDrop = useCallback(
    (e) => {
      e.preventDefault();
      const { target } = e;
      target.classList.remove(classes["drag-active"]);
      target.parentElement.classList.remove(classes["drag-active-error"]);
      const rawData = window.agendaDragData;
      const blockId = target.getAttribute("blockid");

      if (rawData && blockId) {
        const data = JSON.parse(rawData);
        if (!data.draggingDateEnd && !data.draggingDateBegin) {
          const isModifierPressed = e.ctrlKey || e.metaKey;
          const date1 = moment(data.metadata.BeginDate);
          const date2 = moment(data.metadata.EndDate);
          const duration = Math.ceil(date2.diff(date1, "minutes") / 15) * 15;
          const newBegin = moment(gridDate);
          newBegin.set("hours", 0);
          newBegin.set("minutes", 0);
          newBegin.add(parseInt(blockId), "minutes");
          const newEnd = moment(newBegin);
          newEnd.add(duration, "minutes");

          if (newEnd.isSame(newBegin, "day")) {
            if (data.metadata.IsTask) {
              if (isModifierPressed) {
                setIsLoading(true);
                window.TempBeginDate = newBegin.toDate();
                window.TempEndDate = newEnd.toDate();
                duplicateTask({
                  Id: data.metadata.Id,
                });
              } else if (data.metadata.CanEdit && !isModifierPressed) {
                setIsLoading(true);
                const formattedNewEditions = createTaskUpdateForm({
                  Id: data.metadata.Id,
                  BeginDate: dayjs(newBegin.toDate()).format(
                    "YYYY-MM-DDTHH:mm:ssZ",
                  ),
                  EndDate: dayjs(newEnd.toDate()).format(
                    "YYYY-MM-DDTHH:mm:ssZ",
                  ),
                });
                postTask(formattedNewEditions);
              }
            } else if (data.metadata.TempId) {
              if (isModifierPressed && data.metadata.CanDuplicate) {
                setIsLoading(true);
                window.TempBeginDate = newBegin.toDate();
                window.TempEndDate = newEnd.toDate();
                duplicateIntervention({
                  Id: data.metadata.Id,
                });
              } else if (data.metadata.CanEdit && !isModifierPressed) {
                setIsLoading(true);
                const formattedNewEditions = createInterventionUpdateForm({
                  Id: data.metadata.Id,
                  BeginDate: dayjs(newBegin.toDate()).format(
                    "YYYY-MM-DDTHH:mm:ssZ",
                  ),
                  EndDate: dayjs(newEnd.toDate()).format(
                    "YYYY-MM-DDTHH:mm:ssZ",
                  ),
                  TotalPauses: getTotalPause(
                    personalPreferences,
                    newBegin,
                    newEnd,
                    data.metadata.TotalPauses,
                  ),
                });
                postIntervention(formattedNewEditions);
              }
            } else if (!data.metadata.TempId) {
              setIsLoading(true);
              if (isModifierPressed) {
                createPost({
                  BeginDate: dayjs(newBegin.toDate()).format(
                    "YYYY-MM-DDTHH:mm:ssZ",
                  ),
                  EndDate: dayjs(newEnd.toDate()).format(
                    "YYYY-MM-DDTHH:mm:ssZ",
                  ),
                  Description: data.metadata.Description,
                  TotalPauses: getTotalPause(
                    personalPreferences,
                    newBegin,
                    newEnd,
                    data.metadata.TotalPauses,
                  ),
                });
              } else {
                post({
                  Id: data.metadata.Id,
                  BeginDate: dayjs(newBegin.toDate()).format(
                    "YYYY-MM-DDTHH:mm:ssZ",
                  ),
                  EndDate: dayjs(newEnd.toDate()).format(
                    "YYYY-MM-DDTHH:mm:ssZ",
                  ),
                  Description: data.metadata.Description,
                  TotalPauses: getTotalPause(
                    personalPreferences,
                    newBegin,
                    newEnd,
                    data.metadata.TotalPauses,
                  ),
                });
              }
            }
          }
          //only when end Date is midnight of the next day
          else {
            newEnd.subtract(1, "minutes");
            if (newEnd.isSame(newBegin, "day")) {
              if (data.metadata.TempId) {
                if (isModifierPressed && data.metadata.CanDuplicate) {
                  setIsLoading(true);
                  window.TempBeginDate = newBegin.toDate();
                  window.TempEndDate = newEnd.toDate();
                  duplicateIntervention({
                    Id: data.metadata.Id,
                  });
                } else if (data.metadata.CanEdit && !isModifierPressed) {
                  setIsLoading(true);
                  postIntervention({
                    Id: data.metadata.Id,
                    BeginDate: dayjs(newBegin.toDate()).format(
                      "YYYY-MM-DDTHH:mm:ssZ",
                    ),
                    EndDate: dayjs(newEnd.toDate()).format(
                      "YYYY-MM-DDTHH:mm:ssZ",
                    ),
                    TotalPauses: getTotalPause(
                      personalPreferences,
                      newBegin,
                      newEnd,
                      data.metadata.TotalPauses,
                    ),
                  });
                }
              } else if (!data.metadata.TempId) {
                setIsLoading(true);
                if (isModifierPressed) {
                  createPost({
                    BeginDate: dayjs(newBegin.toDate()).format(
                      "YYYY-MM-DDTHH:mm:ssZ",
                    ),
                    EndDate: dayjs(newEnd.toDate()).format(
                      "YYYY-MM-DDTHH:mm:ssZ",
                    ),
                    Description: data.metadata.Description,
                    TotalPauses: getTotalPause(
                      personalPreferences,
                      newBegin,
                      newEnd,
                      data.metadata.TotalPauses,
                    ),
                  });
                } else {
                  post({
                    Id: data.metadata.Id,
                    BeginDate: dayjs(newBegin.toDate()).format(
                      "YYYY-MM-DDTHH:mm:ssZ",
                    ),
                    EndDate: dayjs(newEnd.toDate()).format(
                      "YYYY-MM-DDTHH:mm:ssZ",
                    ),
                    Description: data.metadata.Description,
                    TotalPauses: getTotalPause(
                      personalPreferences,
                      newBegin,
                      newEnd,
                      data.metadata.TotalPauses,
                    ),
                  });
                }
              }
            }
          }
        } else if (data.draggingDateBegin) {
          if (data.metadata.IsTask) {
            setIsLoading(true);
            const formattedNewEditions = createInterventionUpdateForm({
              Id: data.metadata.Id,
              BeginDate: dayjs(new Date(data.NewDateBegin)).format(
                "YYYY-MM-DDTHH:mm:ssZ",
              ),
              EndDate: dayjs(new Date(data.metadata.EndDate)).format(
                "YYYY-MM-DDTHH:mm:ssZ",
              ),
            });
            postTask(formattedNewEditions);
          } else if (data.metadata.TempId && data.metadata.CanEdit) {
            setIsLoading(true);
            const formattedNewEditions = createInterventionUpdateForm({
              Id: data.metadata.Id,
              BeginDate: dayjs(new Date(data.NewDateBegin)).format(
                "YYYY-MM-DDTHH:mm:ssZ",
              ),
              EndDate: dayjs(new Date(data.metadata.EndDate)).format(
                "YYYY-MM-DDTHH:mm:ssZ",
              ),
              TotalPauses: getTotalPause(
                personalPreferences,
                data.NewDateBegin,
                data.metadata.EndDate,
                data.metadata.TotalPauses,
              ),
            });
            postIntervention(formattedNewEditions);
          } else if (!data.metadata.TempId) {
            setIsLoading(true);
            post({
              Id: data.metadata.Id,
              BeginDate: dayjs(new Date(data.NewDateBegin)).format(
                "YYYY-MM-DDTHH:mm:ssZ",
              ),
              EndDate: dayjs(new Date(data.metadata.EndDate)).format(
                "YYYY-MM-DDTHH:mm:ssZ",
              ),
              Description: data.metadata.Description,
              TotalPauses: getTotalPause(
                personalPreferences,
                data.NewDateBegin,
                data.metadata.EndDate,
                data.metadata.TotalPauses,
              ),
            });
          }
        } else if (data.draggingDateEnd) {
          if (data.metadata.IsTask) {
            setIsLoading(true);
            const formattedNewEditions = createInterventionUpdateForm({
              Id: data.metadata.Id,
              BeginDate: dayjs(new Date(data.metadata.BeginDate)).format(
                "YYYY-MM-DDTHH:mm:ssZ",
              ),
              EndDate: dayjs(new Date(data.NewDateEnd)).format(
                "YYYY-MM-DDTHH:mm:ssZ",
              ),
            });
            postTask(formattedNewEditions);
          } else if (data.metadata.TempId && data.metadata.CanEdit) {
            setIsLoading(true);
            const formattedNewEditions = createInterventionUpdateForm({
              Id: data.metadata.Id,
              BeginDate: dayjs(new Date(data.metadata.BeginDate)).format(
                "YYYY-MM-DDTHH:mm:ssZ",
              ),
              EndDate: dayjs(new Date(data.NewDateEnd)).format(
                "YYYY-MM-DDTHH:mm:ssZ",
              ),
              TotalPauses: getTotalPause(
                personalPreferences,
                data.metadata.BeginDate,
                data.NewDateEnd,
                data.metadata.TotalPauses,
              ),
            });
            postIntervention(formattedNewEditions);
          } else if (!data.metadata.TempId) {
            setIsLoading(true);
            post({
              Id: data.metadata.Id,
              BeginDate: dayjs(new Date(data.metadata.BeginDate)).format(
                "YYYY-MM-DDTHH:mm:ssZ",
              ),
              EndDate: dayjs(new Date(data.NewDateEnd)).format(
                "YYYY-MM-DDTHH:mm:ssZ",
              ),
              Description: data.metadata.Description,
              TotalPauses: getTotalPause(
                personalPreferences,
                data.metadata.BeginDate,
                data.NewDateEnd,
                data.metadata.TotalPauses,
              ),
            });
          }
        }
      }
    },
    [
      createInterventionUpdateForm,
      createPost,
      createTaskUpdateForm,
      duplicateIntervention,
      duplicateTask,
      gridDate,
      personalPreferences,
      post,
      postIntervention,
      postTask,
      setIsLoading,
    ],
  );

  const handleDragEnter = useCallback(
    (e) => {
      e.preventDefault();
      // console.log(e);
      const { target } = e;
      const rawData = window.agendaDragData;
      if (rawData) {
        const blockId = target.getAttribute("blockid");
        const data = JSON.parse(rawData);
        if (!data.draggingDateBegin && !data.draggingDateEnd) {
          const gridDateMoment = moment(gridDate);
          gridDateMoment.set("hours", 0);
          gridDateMoment.set("minutes", 0);
          gridDateMoment.add(parseInt(blockId), "Minutes");

          const date1 = moment(data.metadata.BeginDate);
          const date2 = moment(data.metadata.EndDate);
          const duration = Math.ceil(date2.diff(date1, "minutes") / 15) * 15;

          let NewDateEnd = moment(gridDateMoment);

          if (duration === 15 && gridDateMoment.format("HH:mm") === "23:45")
            NewDateEnd.add(14, "minutes");
          else NewDateEnd.add(duration - 15, "minutes");

          if (gridDateMoment.isSame(NewDateEnd, "day")) {
            target.parentElement.classList.remove(classes["drag-active-error"]);
            setSelectedDate((old) => {
              return {
                timeA: gridDateMoment.toDate(),
                timeB: NewDateEnd.toDate(),
              };
            });
          } else {
            NewDateEnd = moment(gridDate);
            NewDateEnd.set("hours", 23);
            NewDateEnd.set("minutes", 59);

            setSelectedDate((old) => {
              return {
                timeA: gridDateMoment.toDate(),
                timeB: NewDateEnd.toDate(),
              };
            });
            target.parentElement.classList.add(classes["drag-active-error"]);
            // setSelectedDate({ timeA: null, timeB: null });
          }

          // target.classList.add(classes["drag-active"]);
          return;
        } else {
          const gridDateMoment = moment(gridDate);
          gridDateMoment.set("hours", 0);
          gridDateMoment.set("minutes", 0);
          gridDateMoment.add(parseInt(blockId), "Minutes");

          if (!gridDateMoment.isSame(data.metadata.BeginDate, "day")) return;

          if (data.draggingDateBegin) {
            const { EndDate } = data.metadata;
            const InitialBeginDateMoment = moment(EndDate);
            if (InitialBeginDateMoment.minutes() === 59)
              InitialBeginDateMoment.subtract(14, "minutes");
            else InitialBeginDateMoment.subtract(15, "minutes");

            if (gridDateMoment.isSameOrBefore(InitialBeginDateMoment)) {
              const NewDateBegin = gridDateMoment.toDate();
              setSelectedDate((old) => {
                return { ...old, timeA: NewDateBegin };
              });
              window.agendaDragData = JSON.stringify({
                ...data,
                NewDateBegin: NewDateBegin.toISOString(),
              });
            }
          } else if (data.draggingDateEnd) {
            const { BeginDate } = data.metadata;
            const InitialEndDateMoment = moment(BeginDate);
            if (gridDateMoment.isSameOrAfter(InitialEndDateMoment)) {
              const NewDateEnd = gridDateMoment.toDate();
              const resolvedEndDate = moment(gridDateMoment);

              if (resolvedEndDate.format("HH:mm") === "23:45")
                resolvedEndDate.add(14, "minutes");
              else resolvedEndDate.add(15, "minutes");

              setSelectedDate((old) => {
                return { ...old, timeB: NewDateEnd };
              });

              window.agendaDragData = JSON.stringify({
                ...data,
                NewDateEnd: resolvedEndDate.toDate().toISOString(),
              });
            }
          }
        }
      }
    },
    [gridDate, setSelectedDate],
  );

  return (
    <div
      blockid={blockid}
      onMouseUp={onMouseUp}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      onDragOver={(e) => {
        e.preventDefault();

        if (e.ctrlKey) {
          e.dataTransfer.dropEffect = "copy"; // Ícone de "+" (Cópia)
        } else {
          e.dataTransfer.dropEffect = "move"; // Ícone de seta (Mover)
        }
      }}
      onDragEnter={handleDragEnter}
      onDragLeave={(e) => {
        e.preventDefault();
        const { target } = e;
        // target.classList.remove(classes["drag-active"]);
        // target.parentElement.classList.remove(classes["drag-active-error"]);
      }}
      onDrop={onDrop}
      className={classnames(
        classes.dayHourItem,
        (blockid + 15) % 60 !== 0 ? classes["borderDashedClass"] : "",
        isOnAgenda && selected ? classes["drag-active"] : "",
        isOnAgenda && isWeekend ? classes.weekendItemBackground : "",
        isOnAgenda && isOutsideWorkHours ? classes.weekendItemBackground : "",
        isOnAgenda && isHoliday ? classes.holidayItemBackground : "",
        isOnAgenda && !isOutsideWorkHours ? classes.workItemBackground : "",
      )}
    ></div>
  );
};

const baseHeight = 60;

const hourMilsec = dayMilsec / 24;
window.getSize = getSize;

const ItemDetails = ({ settings, item, setSelectedDate, height }) => {
  const { Id, TempId, CanEdit, WasDeleted, IsTask, ...rest } = item.metadata;

  const refetchRef = useReftchRefProvider();
  const {
    onPopupMouseEnter,
    onPopupMouseLeave,
    onAnchorMouseEnter,
    onAnchorMouseLeave,
    isOpen,
  } = useHoverEvents();
  const [isLoading, _] = useContext(UpdatingItemsContext);
  const anchorRef = useRef();
  const personalPreferences = useAgendaPreferences();
  const openForm = useEntitySummarySidebar();
  const setView = useContext(SidebarViewSetterContext);
  const currentView = useContext(SidebarViewContext);
  const initialViewRef = useRef();
  const selectedUser = useContext(AgendaSelectedUserContext);
  const currentUser = useCurrentAccount();
  //console.log(initialViewRef.current)

  useEffect(() => {
    if (!initialViewRef.current) initialViewRef.current = currentView;
  }, [currentView]);

  const handleGoBackToOldView = useCallback(() => {
    setView(1, true);
  }, [setView]);

  const { moduleType, EntityPopup, WeeklyItem, schema } = settings;
  const openSidebar = useEntitySummarySidebar();

  const handleClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (IsTask) {
        setView(2, true);
        onAnchorMouseLeave();
        openForm({
          type: moduleTypes.tasks,
          props: {
            id: Id,
            handleGoBackToOldView,
            personalPreferences,
            refetchCalendar: () => {
              if (refetchRef.current) refetchRef.current();
            },
          },
        });
      } else if (moduleType === "spaceAgenda" && TempId) {
        setView(2, true);
        onAnchorMouseLeave();
        if (CanEdit) {
          openForm({
            type: moduleTypes.interventions,
            props: {
              edit: CanEdit,
              id: Id,
              handleGoBackToOldView,
              personalPreferences,
              showDuplicateButton:
                !selectedUser || selectedUser === currentUser.Id,
              refetchCalendar: () => {
                if (refetchRef.current) refetchRef.current();
              },
            },
          });
        } else {
          openSidebar({
            type: moduleTypes.interventions,
            props: {
              edit: CanEdit,
              id: Id,
              handleGoBackToOldView,
              personalPreferences,
              refetchCalendar: () => {
                if (refetchRef.current) refetchRef.current();
              },
            },
          });
        }
      } else if (moduleType === "spaceAgenda") {
        setView(2, true);

        onAnchorMouseLeave();
        openForm({
          type: moduleType,
          props: {
            id: Id,
            viewOutlookEvent: typeof Id === "number" ? false : true,
            handleGoBackToOldView,
            personalPreferences,
            selectedUser,
            refetchCalendar: () => {
              if (refetchRef.current) refetchRef.current();
            },
          },
        });
      } else {
        onAnchorMouseLeave();
        setView(2, true);
        if (CanEdit) {
          openForm({
            type: moduleType,
            props: {
              id: Id,
              edit: CanEdit,
              handleGoBackToOldView,
              showDuplicateButton:
                !selectedUser || selectedUser === currentUser.Id,
              refetchCalendar: () => {
                if (refetchRef.current) refetchRef.current();
              },
            },
          });
        } else {
          openSidebar({
            type: moduleType,
            props: {
              id: Id,
              handleGoBackToOldView,
              refetchCalendar: () => {
                if (refetchRef.current) refetchRef.current();
              },
            },
          });
        }
      }
    },
    [
      CanEdit,
      Id,
      IsTask,
      TempId,
      currentUser.Id,
      handleGoBackToOldView,
      moduleType,
      onAnchorMouseLeave,
      openForm,
      openSidebar,
      personalPreferences,
      refetchRef,
      selectedUser,
      setView,
    ],
  );

  const handleDragBeginStart = useCallback(
    (e) => {
      e.stopPropagation();
      // use a 1x1 transparent image as drag image (some browsers don't accept null)
      const ghost = new Image();
      ghost.src =
        "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
      // append so some browsers can render it
      document.body.appendChild(ghost);
      try {
        e.dataTransfer.setDragImage(ghost, 0, 0);
      } catch (err) {
        // ignore if setDragImage fails
      }
      // remove the element shortly after so it doesn't linger in the DOM
      setTimeout(() => {
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      }, 0);
      if (anchorRef.current) {
        setTimeout(() => {
          anchorRef.current.parentElement.style.zIndex = "-1";
        }, 0);
      }

      window.agendaDragData = JSON.stringify({
        ...item,
        draggingDateBegin: true,
      });
      const resolvedEndDate = moment(item.metadata.EndDate);
      if (resolvedEndDate.minutes() === 59)
        resolvedEndDate.subtract(14, "minutes");
      else resolvedEndDate.subtract(15, "minutes");
      setSelectedDate({
        timeA: new Date(item.metadata.BeginDate),
        timeB: resolvedEndDate.toDate(),
      });
    },
    [item, setSelectedDate],
  );

  const handleDragEnd = useCallback(
    (e) => {
      e.stopPropagation();
      window.agendaDragData = null;
      if (anchorRef.current) anchorRef.current.parentElement.style.zIndex = "1";
      setSelectedDate({
        timeA: null,
        timeB: null,
      });
    },
    [setSelectedDate],
  );

  const handleDragEndStart = useCallback(
    (e) => {
      e.stopPropagation();
      // use a 1x1 transparent image as drag image (some browsers don't accept null)
      const ghost = new Image();
      ghost.src =
        "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
      // append so some browsers can render it
      document.body.appendChild(ghost);
      try {
        e.dataTransfer.setDragImage(ghost, 0, 0);
      } catch (err) {
        // ignore if setDragImage fails
      }
      // remove the element shortly after so it doesn't linger in the DOM
      setTimeout(() => {
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      }, 0);
      if (anchorRef.current) {
        setTimeout(() => {
          anchorRef.current.parentElement.style.zIndex = "-1";
        }, 0);
      }
      window.agendaDragData = JSON.stringify({
        ...item,
        draggingDateEnd: true,
      });
      const resolvedEndDate = moment(item.metadata.EndDate);
      resolvedEndDate.subtract(15, "minutes");

      setSelectedDate({
        timeA: new Date(item.metadata.BeginDate),
        timeB: resolvedEndDate.toDate(),
      });
    },
    [item, setSelectedDate],
  );

  const isAlgTime = useMemo(() => {
    const { Client, IndirectClient } = item.metadata;

    return Client === 13424 || IndirectClient === 13424;
  }, [item.metadata]);

  const resolvedCanDrag = useMemo(() => {
    if (isLoading) return false;
    // if (TempId && !CanEdit) return false;
    if (WasDeleted) return false;
    if (settings.AllowDragDrop !== undefined) return settings.AllowDragDrop;

    return false;
  }, [WasDeleted, isLoading, settings.AllowDragDrop]);

  const resolvedCanResize = useMemo(() => {
    if (isLoading) return false;
    if (TempId && !CanEdit) return false;
    if (WasDeleted) return false;
    if (settings.AllowDragDrop !== undefined) return settings.AllowDragDrop;

    return false;
  }, [CanEdit, TempId, WasDeleted, isLoading, settings.AllowDragDrop]);

  const isAusencia = useMemo(
    () =>
      item?.metadata?.InterventionType === 3607 ||
      item?.metadata?.InterventionType === 3545,
    [item.metadata],
  );

  const isHoliday = useMemo(
    () =>
      item?.metadata?.InterventionType === 3606 ||
      item?.metadata?.InterventionType === 3527 ||
      item?.metadata?.InterventionType === 5207 ||
      item?.metadata?.InterventionType === 5208,
    [item.metadata],
  );

  const isOutlookEvent = useMemo(
    () => Boolean(item?.metadata?._isOutlookEvent),
    [item.metadata],
  );

  return (
    <>
      <div
        onDoubleClick={handleClick}
        className={classnames(
          "h-100 position-relative",
          IsTask
            ? classes["bg-task-item"]
            : isOutlookEvent
              ? classes["bg-outlook"]
              : item.metadata.TempId
                ? isHoliday
                  ? classes["bg-holidayItem"]
                  : isAusencia
                    ? classes["bg-ausencia"]
                    : isAlgTime
                      ? classes["bg-alg"]
                      : "bg-secondary-light"
                : item.metadata.WasDeleted
                  ? classes["bg-deleted"]
                  : classes["bg-postIt"],
        )}
        onMouseEnter={onAnchorMouseEnter}
        onMouseLeave={onAnchorMouseLeave}
        ref={anchorRef}
      >
        <div
          draggable={resolvedCanResize}
          onDragStart={handleDragBeginStart}
          onDragEnd={handleDragEnd}
          style={{ height: 4, top: 0 }}
          className={classnames(
            "position-absolute w-100 cursor-s-resize",
            !resolvedCanDrag && "d-none",
          )}
        ></div>
        <div
          className={classnames(
            "px-1 text-truncate h-100 truncate of-hidden",
            height <= 15 ? "fs-10" : height <= 30 ? "fs-10 py-1" : "fs-12 py-1",
          )}
        >
          <ColorFilterBars entity={item.metadata} />

          <WeeklyItem item={item} />
        </div>
        <div
          onDragStart={handleDragEndStart}
          onDragEnd={handleDragEnd}
          draggable={resolvedCanResize}
          style={{ height: 4, bottom: 0 }}
          className={classnames(
            "position-absolute w-100 cursor-s-resize",
            !resolvedCanDrag && "d-none",
          )}
        ></div>
      </div>
      {schema.name !== "SpaceAgenda" ? (
        <Popup
          placement="left"
          anchorEl={anchorRef.current}
          isOpen={isOpen}
          onMouseEnter={onPopupMouseEnter}
          onMouseLeave={onPopupMouseLeave}
        >
          <EntityPopup entityId={Id} />
          {/* <TaskOriginPopup task={value} /> */}
        </Popup>
      ) : (
        <></>
      )}
    </>
  );
};

const GridColmnItem = ({
  item,
  gridDate,
  left,
  width,
  settings,
  setSelectedDate,
  itemsBefore,
}) => {
  const [isLoading, _] = useContext(UpdatingItemsContext);
  const { BeginDate, EndDate, ...rest } = item;
  const { AllowDragDrop } = settings;
  const maxDate = new Date(gridDate);

  maxDate.setDate(maxDate.getDate() + 1);
  // const resolvedBeginDate = BeginDate < gridDate ? gridDate : BeginDate;
  // const resolvedEndDate = EndDate > maxDate ? maxDate : EndDate;

  const durationMil = EndDate.getTime() - BeginDate.getTime();

  const height = (durationMil * baseHeight) / hourMilsec;

  const startMil = BeginDate.getHours();

  const itemRef = useRef();

  const top =
    startMil * baseHeight + BeginDate.getMinutes() * (baseHeight / 60);
  // const startMil = resolvedBeginDate.getTime() - gridDate.getTime();

  // const top = (startMil * baseHeight) / hourMilsec;

  const handleDragStart = useCallback(
    (e) => {
      window.agendaDragData = JSON.stringify(item);
      e.dataTransfer.setDragImage(e.target, 10, 10);
      e.dataTransfer.dropEffect = "move";
      setTimeout(() => {
        if (itemRef.current) {
          itemRef.current.style.zIndex = "-1";
        }
      }, 0);
    },
    [item],
  );

  const handleDragEnd = useCallback(
    (e) => {
      window.agendaDragData = null;
      if (itemRef.current) {
        itemRef.current.style.zIndex = "1";
      }
      setSelectedDate({ timeA: null, timeB: null });
      e.target.parentElement.classList.remove(classes["drag-active-error"]);
    },
    [setSelectedDate],
  );

  const canDrag = useMemo(() => {
    if (isLoading) return false;
    // if (item.metadata.TempId && !item.metadata.CanEdit) return false;
    if (item.metadata.WasDeleted) return false;
    return Boolean(AllowDragDrop);
  }, [AllowDragDrop, isLoading, item.metadata.WasDeleted]);

  return (
    <div
      ref={itemRef}
      something={item.metadata.Id}
      draggable={canDrag}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      style={{ width: `calc(${width}%)`, left: `${left}%`, height, top }}
      className={classnames(
        "text-el overflow-hidden text-truncate",
        classes.columnItem,
      )}
    >
      <ItemDetails
        item={item}
        height={height}
        settings={settings}
        setSelectedDate={setSelectedDate}
      />
      {/* <div title={item.metadata.Id} className="h-100 p-1 text-truncate">
        {item.metadata.Id}
      </div> */}
    </div>
  );
};

const GridColumnItems = ({ items, gridDate, settings, setSelectedDate }) => {
  const resolvedValues = useMemo(
    () => items.length > 0 && getResolvedSizes(items),
    [items],
  );

  if (items.length === 0) return null;

  // const itemsPerLevel = [];
  // for (const item of items) {
  //   const { BeginDate, EndDate, metadata } = item;

  //   let currentLevel = 0;

  //   const resolvedBeginDate =
  //     BeginDate < gridDate ? new Date(gridDate) : BeginDate;
  //   const resolvedEndDate =
  //     EndDate.getTime() > gridDate.getTime() + dayMilsec
  //       ? new Date(gridDate.getTime() + dayMilsec)
  //       : EndDate;

  //   const newItem = {
  //     BeginDate: resolvedBeginDate,
  //     EndDate: resolvedEndDate,
  //     metadata,
  //   };

  //   let hasFinished = false;

  //   while (!hasFinished) {
  //     const doesConflict = doItemsConflict(item, itemsPerLevel[currentLevel]);
  //     if (doesConflict) currentLevel++;
  //     else {
  //       hasFinished = true;
  //     }
  //   }

  //   if (!itemsPerLevel[currentLevel]) itemsPerLevel[currentLevel] = [];

  //   itemsPerLevel[currentLevel].push(newItem);
  // }
  // console.log(gridDate);
  // console.log(itemsPerLevel);

  return resolvedValues.map((item, i) => {
    return (
      <GridColmnItem
        settings={settings}
        setSelectedDate={setSelectedDate}
        left={item.left}
        width={item.width}
        itemsBefore={item.itemsBefore}
        gridDate={gridDate}
        item={item.value}
        key={item.value.metadata.Id}
      />
    );
  });
};

// const hourHeight = 15;

const compareDateBothDaysIfInBetween = (target, blockid, dateA, dateB) => {
  if (!target || !dateA || !dateB) return false;
  const resolvedTargetM = moment(target);
  resolvedTargetM.set("hours", 0);
  resolvedTargetM.set("minutes", 0);
  resolvedTargetM.add(blockid, "minutes");
  const resolvedTarget = resolvedTargetM.toDate();
  // resolvedTarget.setHours(hour);
  const resolvedTargetTime = resolvedTarget.getTime();
  const dateADay = dateA.getTime();
  const dateBDay = dateB.getTime();
  // console.log(dateADay, resolvedTargetTime, dateBDay);
  if (
    (dateADay <= resolvedTargetTime && resolvedTargetTime <= dateBDay) ||
    (dateBDay <= resolvedTargetTime && resolvedTargetTime <= dateADay)
  )
    return true;

  return false;
};

let isMouseDownRef = false;

export const WeeklyContentGridColumn = ({
  currentDate,
  startDateMil,
  i,
  items,
  settings,
  holidayData,
  containerRef,
}) => {
  const [selectedDate, setSelectedDate] = useHourSelectorProvider();
  const refetchRef = useReftchRefProvider();
  const { schema, isAgendaTask } = settings;
  const disabledCreation = useCanCreateProvider();
  const personalPreferences = useAgendaPreferences();
  const currentUser = useCurrentAccount();
  const { isSelected, gridDate, isHoliday, isWeekend } = useMemo(() => {
    const gridDate = addDays(startDateMil, i);
    const isSelected = currentDate.toDateString() === gridDate.toDateString();
    let isHoliday = false;
    let isWeekend = false;
    if (Array.isArray(holidayData)) {
      const resolvedPersonalPreferences = personalPreferences || {};
      const momentDate = moment(gridDate);
      const resolvedString = momentDate.format("YYYY-MM-DD");
      const weekDay = momentDate.day();
      const dayObj =
        holidayData.find((h) => {
          const key = h?.DateKey || "";
          return key === resolvedString;
        }) || {};
      isHoliday = dayObj.IsHoliday;
      isWeekend = dayObj.IsWeekend;
      //override if weekend and personal preferences say working day
      if (Array.isArray(resolvedPersonalPreferences.workschedule)) {
        isWeekend = !resolvedPersonalPreferences.workschedule[weekDay]?.enabled;
      }
    }

    return { isSelected, gridDate, isHoliday, isWeekend };
  }, [currentDate, holidayData, i, personalPreferences, startDateMil]);

  const openSidebar = useEntitySummarySidebar();
  const selectedUser = useContext(AgendaSelectedUserContext);
  const setView = useContext(SidebarViewSetterContext);
  const currentView = useContext(SidebarViewContext);
  const initialViewRef = useRef();

  const location = useLocation();

  const isOnAgenda = useMemo(() => {
    return (
      location.pathname.includes("calendar") ||
      location.pathname.includes("timemanager")
    );
  }, [location.pathname]);

  useEffect(() => {
    if (!initialViewRef.current) initialViewRef.current = currentView;
  }, [currentView]);

  const handleGoBackToOldView = useCallback(() => {
    setView(initialViewRef.current, true);
  }, [setView]);

  const handleDoubleClick = useCallback(
    (e) => {
      if (!isOnAgenda) return;
      if (disabledCreation) return;
      const blockId = e.target.getAttribute("blockid");
      const { moduleType } = settings;
   
      // const minutesAhead = Math.floor(blockId / hourHeight) * 15;

      const newDatezero = moment(gridDate);
      newDatezero.set("hours", 0);
      newDatezero.set("minutes", 0);
      newDatezero.add(blockId, "minutes");
      // newDatezero.set("minutes", minutesAhead);

      const newStartDate = newDatezero.toDate();
      const newEndDate = moment(newStartDate);
      if (newEndDate.format("HH:mm") === "23:45") {
        newEndDate.add(14, "minutes");
      } else newEndDate.add(15, "minutes");

      if (moduleType === "spaceAgenda") {
        setView(2, true);
        openSidebar({
          type: moduleType,
          props: {
            defaultForm: {
              BeginDate: newStartDate,
              EndDate: newEndDate.toDate(),
              TotalPauses: getTotalPause(
                personalPreferences,
                newStartDate,
                newEndDate,
                0,
              ),
            },
            personalPreferences,
            selectedUser,
            handleGoBackToOldView,
            refetchCalendar: () => {
              if (refetchRef.current) refetchRef.current();
            },
          },
        });
      } else if (moduleType !== "interventions") {
        setView(2, true);
        openSidebar({
          type: moduleType,
          props: {
            defaultForm: {
              BeginDate: newStartDate,
              EndDate: newEndDate.toDate(),
              TotalPauses: getTotalPause(
                personalPreferences,
                newStartDate,
                newEndDate,
                0,
              ),
              Manager: moduleType === "tasks" ? selectedUser : undefined,
              Followers:
                moduleType === "tasks"
                  ? [selectedUser, currentUser?.Id]
                  : undefined,
            },
            selectedUser,
            refetchCalendar: () => {
              if (refetchRef.current) refetchRef.current();
            },
          },
        });
      } else {
        const d2 = new Date();
        const isBeforeOrSame =
          newStartDate.getFullYear() < d2.getFullYear() ||
          (newStartDate.getFullYear() === d2.getFullYear() &&
            newStartDate.getMonth() < d2.getMonth()) ||
          (newStartDate.getFullYear() === d2.getFullYear() &&
            newStartDate.getMonth() === d2.getMonth() &&
            newStartDate.getDate() <= d2.getDate());
        if (isBeforeOrSame) {
          openSidebar({
            type: moduleType,
            props: {
              defaultForm: {
                BeginDate: newStartDate,
                EndDate: newEndDate.toDate(),
              },
              selectedUser,
              personalPreferences,
              refetchCalendar: () => {
                if (refetchRef.current) refetchRef.current();
              },
            },
          });
        }
      }
    },
    [
      currentUser,
      disabledCreation,
      gridDate,
      handleGoBackToOldView,
      isOnAgenda,
      openSidebar,
      personalPreferences,
      refetchRef,
      selectedUser,
      setView,
      settings,
    ],
  );

  const handleMouseDown = useCallback(
    (e) => {
      if (!isOnAgenda) return;
      if (disabledCreation) return;
      const { moduleType } = settings;
      isMouseDownRef = true;
      const blockId = e.target.getAttribute("blockid");

      // const minutesAhead = blockId;

      const newDatezero = moment(gridDate);
      newDatezero.set("hours", 0);
      newDatezero.set("minutes", 0);
      newDatezero.add(blockId, "minutes");
      // newDatezero.set("minutes", minutesAhead);
      const newStartDate = newDatezero.toDate();

      if (moduleType !== "interventions") {
        setSelectedDate({ timeA: newStartDate, timeB: null });
      } else {
        const d2 = new Date();
        const isBeforeOrSame =
          newStartDate.getFullYear() < d2.getFullYear() ||
          (newStartDate.getFullYear() === d2.getFullYear() &&
            newStartDate.getMonth() < d2.getMonth()) ||
          (newStartDate.getFullYear() === d2.getFullYear() &&
            newStartDate.getMonth() === d2.getMonth() &&
            newStartDate.getDate() <= d2.getDate());
        if (isBeforeOrSame) {
          setSelectedDate({ timeA: newStartDate, timeB: null });
        }
      }
    },
    [disabledCreation, gridDate, isOnAgenda, setSelectedDate, settings],
  );

  const handleMouseEnter = useCallback(
    (e) => {
      if (!isOnAgenda) return;
      const { moduleType, schema } = settings;
      if (!isMouseDownRef) return;
      if (selectedDate.timeA === null) return;
      if (
        (moduleType === "interventions" || schema.name === "SpaceAgenda") &&
        selectedDate.timeA.toDateString() !== gridDate.toDateString()
      )
        return;

      const blockId = e.target.getAttribute("blockid");

      const newDatezero = moment(gridDate);
      newDatezero.set("hours", 0);
      newDatezero.set("minutes", 0);
      newDatezero.add(blockId, "minutes");

      setSelectedDate((old) => {
        return { ...old, timeB: newDatezero.toDate() };
      });
    },
    [gridDate, isOnAgenda, selectedDate.timeA, setSelectedDate, settings],
  );

  const handleMouseUp = useCallback(
    (e) => {
      if (!isOnAgenda) return;

      if (!isMouseDownRef) {
        return;
      }
      isMouseDownRef = false;
      if (selectedDate.timeA === null || selectedDate.timeB === null) return;

      const newStartDate = moment(
        selectedDate.timeA < selectedDate.timeB
          ? selectedDate.timeA
          : selectedDate.timeB,
      );
      const newEndDate = moment(
        selectedDate.timeA > selectedDate.timeB
          ? selectedDate.timeA
          : selectedDate.timeB,
      );

      if (newEndDate.hour() === 23 && newEndDate.minute() === 45) {
        newEndDate.add(14, "minutes");
      } else {
        newEndDate.add(15, "minutes");
      }

      const { moduleType } = settings;

      if (moduleType === "spaceAgenda") {
        setView(2, true);
        openSidebar({
          type: moduleType,
          props: {
            defaultForm: {
              BeginDate: newStartDate.toDate(),
              EndDate: newEndDate.toDate(),
              TotalPauses: getTotalPause(
                personalPreferences,
                newStartDate,
                newEndDate,
                0,
              ),
            },
            personalPreferences,
            selectedUser,
            handleGoBackToOldView,
            refetchCalendar: () => {
              if (refetchRef.current) refetchRef.current();
            },
          },
        });
      } else {
        openSidebar({
          type: moduleType,
          props: {
            defaultForm: {
              BeginDate: newStartDate.toDate(),
              EndDate: newEndDate.toDate(),
              TotalPauses: getTotalPause(
                personalPreferences,
                newStartDate,
                newEndDate,
                0,
              ),
              Manager: moduleType === "tasks" ? selectedUser : undefined,
              Followers:
                moduleType === "tasks"
                  ? [selectedUser, currentUser?.Id]
                  : undefined,
            },
            personalPreferences,
            selectedUser,
            refetchCalendar: () => {
              if (refetchRef.current) refetchRef.current();
            },
          },
        });
      }

      setSelectedDate({ timeA: null, timeB: null });
    },
    [
      currentUser,
      handleGoBackToOldView,
      isOnAgenda,
      openSidebar,
      personalPreferences,
      refetchRef,
      selectedDate,
      selectedUser,
      setSelectedDate,
      setView,
      settings,
    ],
  );

  return (
    <div
      onDoubleClick={handleDoubleClick}
      className={classnames("flex-1", classes.dayHourColumn, {
        [classes.selected]: isSelected,
      })}
    >
      <GridColumnItems
        settings={settings}
        gridDate={gridDate}
        setSelectedDate={setSelectedDate}
        items={items}
      />

      {Array.from({ length: 96 }).map((_, block) => {
        const blokcId = (block + 1) * 15 - 15;
        return (
          <ContentPlaceholderGridItem
            key={block + 1}
            schema={schema}
            isHoliday={isHoliday}
            isWeekend={isWeekend}
            blockid={blokcId}
            gridDate={gridDate}
            setSelectedDate={setSelectedDate}
            onMouseUp={handleMouseUp}
            onMouseDown={handleMouseDown}
            onMouseEnter={handleMouseEnter}
            currentSelectedDate={selectedDate}
            selected={compareDateBothDaysIfInBetween(
              gridDate,
              blokcId,
              selectedDate.timeA,
              selectedDate.timeB,
            )}
          />
        );
      })}
    </div>
  );
};

export const HourSelectorContext = React.createContext();

export const useHourSelectorProvider = () => useContext(HourSelectorContext);

const ContentGrid = ({
  startDateMil,
  items,
  settings,
  containerRef,
  workWeek,
  holidayData,
}) => {
  const currentDate = useMemo(() => {
    const date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }, []);
  const agendaPreferences = useAgendaPreferences();
  const [selectedDate, setSelectedDate] = useState({
    timeA: null,
    timeB: null,
  });

  const { gridItems } = items;
  const timeoutRef = useRef();

  const [currentTimePos, setCurrentTimePos] = useState(() => {
    const currentTime = moment();
    const startMil = currentTime.hours();
    return startMil * baseHeight + currentTime.minutes();
  });

  useEffect(() => {
    if (timeoutRef.current) {
      clearInterval(timeoutRef.current);
    }
    timeoutRef.current = setInterval(() => {
      const currentTime = moment();
      const startMil = currentTime.hours();
      setCurrentTimePos(startMil * baseHeight + currentTime.minutes());
    }, 60000);

    return () => {
      if (timeoutRef.current) {
        clearInterval(timeoutRef.current);
      }
    };
  }, []);

  if (workWeek) {
    const workSchedule = agendaPreferences?.workschedule || [];

    const workingDaysIndexes = workSchedule.filter((day) => day.enabled);
    if (workingDaysIndexes.length > 0)
      return (
        <div className="flex-1 position-relative d-flex">
          <div
            style={{ top: currentTimePos }}
            className={classes.currentTimeBar}
          ></div>
          <HourSelectorContext.Provider value={[selectedDate, setSelectedDate]}>
            {workingDaysIndexes.map((obj) => (
              <WeeklyContentGridColumn
                key={`workweek-col-${obj.day}`}
                containerRef={containerRef}
                settings={settings}
                holidayData={holidayData}
                startDateMil={startDateMil}
                i={obj.day}
                currentDate={currentDate}
                items={gridItems[obj.day]}
              />
            ))}
          </HourSelectorContext.Provider>
        </div>
      );
  }

  return (
    <div className="flex-1 position-relative d-flex">
      <div
        style={{ top: currentTimePos }}
        className={classes.currentTimeBar}
      ></div>
      <HourSelectorContext.Provider value={[selectedDate, setSelectedDate]}>
        <WeeklyContentGridColumn
          containerRef={containerRef}
          settings={settings}
          holidayData={holidayData}
          startDateMil={startDateMil}
          i={0}
          currentDate={currentDate}
          items={gridItems[0]}
        />
        <WeeklyContentGridColumn
          containerRef={containerRef}
          settings={settings}
          holidayData={holidayData}
          startDateMil={startDateMil}
          i={1}
          currentDate={currentDate}
          items={gridItems[1]}
        />
        <WeeklyContentGridColumn
          containerRef={containerRef}
          settings={settings}
          startDateMil={startDateMil}
          holidayData={holidayData}
          i={2}
          currentDate={currentDate}
          items={gridItems[2]}
        />
        <WeeklyContentGridColumn
          containerRef={containerRef}
          holidayData={holidayData}
          settings={settings}
          startDateMil={startDateMil}
          i={3}
          currentDate={currentDate}
          items={gridItems[3]}
        />
        <WeeklyContentGridColumn
          containerRef={containerRef}
          settings={settings}
          startDateMil={startDateMil}
          holidayData={holidayData}
          i={4}
          currentDate={currentDate}
          items={gridItems[4]}
        />
        <WeeklyContentGridColumn
          containerRef={containerRef}
          settings={settings}
          holidayData={holidayData}
          startDateMil={startDateMil}
          i={5}
          currentDate={currentDate}
          items={gridItems[5]}
        />
        <WeeklyContentGridColumn
          containerRef={containerRef}
          settings={settings}
          holidayData={holidayData}
          startDateMil={startDateMil}
          i={6}
          currentDate={currentDate}
          items={gridItems[6]}
        />
      </HourSelectorContext.Provider>
    </div>
  );
};

const selector = (v) => {
  return v;
};

const sortColumnItems = (items) => {
  // const minRowDay = gridNum * 7 + 1;
  // const maxRowDay = minRowDay + 6;

  // const newArr = [];
  // for (const item of items) {
  //   const { gridStartDay, gridEndDay } = item;
  //   const rowStartDay = gridStartDay < minRowDay ? minRowDay : gridStartDay;
  //   const rowEndDay = gridEndDay > maxRowDay ? maxRowDay : gridEndDay;
  //   const totalRowDays = rowEndDay - rowStartDay + 1;
  //   newArr.push({ ...item, rowStartDay, rowEndDay, totalRowDays });
  // }

  const sortedArr = items.sort((a, b) => {
    return a.epochStart - b.epochStart || a.epochEnd - b.epochEnd;
  });

  return sortedArr;
};

export const buildResolvedWeeklyValueItem = (v, settings, startDate) => {
  const { BeginDateFieldObj, EndDateFieldObj } = settings;
  let BeginDate = new Date(
    BeginDateFieldObj ? v[BeginDateFieldObj] : v.BeginDate,
  );
  BeginDate.setSeconds(5);
  BeginDate.setMilliseconds(0);
  let EndDate = new Date(
    EndDateFieldObj ? v[EndDateFieldObj] : v.EndDate || BeginDate,
  );
  EndDate.setSeconds(0);
  EndDate.setMilliseconds(0);

  let epochStart = BeginDate.getTime();
  let epochEnd = EndDate.getTime();

  // if (epochEnd - epochStart < 3600000) {
  //   EndDate.setHours(BeginDate.getHours() + 1);
  //   EndDate.setMinutes(0);
  //   epochEnd = EndDate.getTime();
  // }

  const epochStartDay = calendarToEpochDays(BeginDate);
  const epochEndDay = calendarToEpochDays(EndDate);

  const epochGridStartDate = calendarToEpochDays(startDate);

  let gridStartDay = epochStartDay - epochGridStartDate;
  let gridEndDay = epochEndDay - epochGridStartDate;

  if (gridEndDay > 7) {
    gridEndDay = 7;
  }

  const newV = {
    gridStartDay,
    gridEndDay,
    epochStart,
    epochEnd,
    // epochStartDay,
    // epochEndDay,
    // totalDays: epochEndDay - epochStartDay,
    BeginDate,
    EndDate,
    metadata: v,
  };

  return newV;
};

const useWeekGridItems = (data, startDate, settings, multipleDay) => {
  return useMemo(() => {
    const gridItems = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] };

    if (!data || data.length === 0) {
      return { gridItems };
    }

    const resolvedDictionaryForIndexToDate = {};
    const singularStartMoment = moment(startDate);
    for (let index = 0; index <= 6; index++) {
      resolvedDictionaryForIndexToDate[singularStartMoment.date()] = index;
      singularStartMoment.add(1, "day");
    }

    const resolvedResults = data
      .filter((t) => !t.IsDeleted)
      .map((v) => buildResolvedWeeklyValueItem(v, settings, startDate));

    const outOfGridItems = [];

    for (const item of resolvedResults) {
      const {
        epochStart,
        epochEnd,
        gridStartDay,
        gridEndDay,
        metadata: { IsAllDay },
      } = item;

      if (IsAllDay) {
        outOfGridItems.push(item);
        continue;
      }

      // Anything crossing a day boundary goes to the header row as a
      // horizontal bar. Duration alone missed the 09:00->09:00-next-day case:
      // buildResolvedWeeklyValueItem sets BeginDate seconds to 5, so it lands
      // 5s under dayMilsec and used to render as one 24h block in a column.
      // -1ms so an item ending exactly at midnight stays on its own day.
      if (!moment(epochStart).isSame(epochEnd - 1, "day")) {
        outOfGridItems.push(item);
        continue;
      }

      if (multipleDay) {
        const index =
          resolvedDictionaryForIndexToDate[item.BeginDate.getDate()];
        if (gridItems[index]) gridItems[index].push(item);
        continue;
      }

      const firstGrid = gridStartDay;
      const lastGrid = gridEndDay;

      for (let i = firstGrid; i <= lastGrid; i++) {
        if (gridItems[i]) gridItems[i].push(item);
      }
    }

    gridItems[0] = sortColumnItems(gridItems[0]);
    gridItems[1] = sortColumnItems(gridItems[1]);
    gridItems[2] = sortColumnItems(gridItems[2]);
    gridItems[3] = sortColumnItems(gridItems[3]);
    gridItems[4] = sortColumnItems(gridItems[4]);
    gridItems[5] = sortColumnItems(gridItems[5]);
    gridItems[6] = sortColumnItems(gridItems[6]);

    // console.log(gridItems);

    return { gridItems, outOfGridItems };
  }, [data, multipleDay, settings, startDate]);
};

const ItemsHeader = ({
  outOfGridItems,
  settings,
  startDate,
  multipleDay,
  overrideNumberofOutofBound,
  gridRowEndDay,
}) => {
  const x = useMemo(() => {
    const x = outOfGridItems.map((v) =>
      buildResolvedValueItem(v.metadata, settings, startDate, multipleDay),
    );

    return sortRowItems(x, 0);
  }, [outOfGridItems, settings, startDate, multipleDay]);

  const { children, elapsedDays } = buildItems(
    x,
    0,
    overrideNumberofOutofBound || 3,
    startDate,
    settings,
    { gridRowEndDay },
  );
  return (
    <div
      className="d-flex border-bottom"
      style={
        {
          // padding: "4px 0px 0px 52px",
        }
      }
    >
      <div
        className={classnames(
          classes.hourList,
          classes.hourItem,
          "h-100 border-0",
        )}
      ></div>
      <div
        className="flex-1"
        style={{
          position: "relative",
          height: 29 * elapsedDays,
          margin: "4px 0px 0px 0px",
        }}
      >
        {children}
      </div>
      <div className={classes.fakeScroll} />
    </div>
  );
};

const UpdatingItemsContext = React.createContext();

export const UpdatingItemsProvider = ({ children, workWeek }) => {
  const [isLoading, setIsLoading] = useState(false);
  const mountedRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const prevWorkViewRef = useRef(workWeek);

  useEffect(() => {
    // if we just changed from normal view to work view while loading, cancel loading
    if (!prevWorkViewRef.current && workWeek) {
      if (mountedRef.current && isLoading) {
        setIsLoading(false);
      }
    }
    prevWorkViewRef.current = workWeek;
  }, [workWeek, isLoading]);

  const handleLoading = useCallback((e) => {
    if (mountedRef.current) {
      setIsLoading(e);
    }
  }, []);

  return (
    <UpdatingItemsContext.Provider value={[isLoading, handleLoading]}>
      {children}
    </UpdatingItemsContext.Provider>
  );
};

export const IntermediaryBarLoader = ({ loading }) => {
  const [isLoading, _] = useContext(UpdatingItemsContext);
  return <BarLoader isLoading={loading || isLoading} />;
};

const InnerCalendarViewAgenda = ({
  dateInfo,
  settings,
  holidayData,
  multipleDay,
  data,
  workWeek,
  loading,
}) => {
  const { startDateMil, startDate, endDate } = dateInfo;

  const { schema } = settings;

  const connectedResults = useMultipleEntityValueSelector(
    schema,
    data?.appointments || [],
    selector,
  );
  const connectedResults2 = useMultipleEntityValueSelector(
    spaceInterventionsSchema,
    data?.times || [],
    selector,
  );

  const connectedResults3 = useMultipleEntityValueSelector(
    spaceOutlookEventsSchema,
    data?.outlookEvents || [],
    selector,
  );

  const connectedResults4 = useMultipleEntityValueSelector(
    spaceTasksSchema,
    data?.tasks || [],
    selector,
  );

  const resolvedConnectedResults = useMemo(
    () => [
      ...connectedResults,
      ...connectedResults2,
      ...connectedResults3,
      ...connectedResults4,
    ],
    [connectedResults, connectedResults2, connectedResults3, connectedResults4],
  );

  const items = useWeekGridItems(
    resolvedConnectedResults,
    startDate,
    settings,
    multipleDay,
  );

  const outOfGridItems = useMemo(() => {
    return items && Array.isArray(items.outOfGridItems)
      ? [...items.outOfGridItems]
      : [];
  }, [items]);

  const containerRef = useRef();

  return (
    <div
      className={classnames(
        "flex-1 w-100 d-flex flex-column position-relative rounded border-top-0",
        classes.weekView,
      )}
    >
      <IntermediaryBarLoader loading={loading} />
      <WeekDayHeader
        workWeek={workWeek}
        items={items}
        multipleDay={multipleDay}
        startMil={startDateMil}
        holidayData={holidayData}
      />
      {outOfGridItems && outOfGridItems.length > 0 && (
        <ItemsHeader
          outOfGridItems={outOfGridItems}
          settings={settings}
          startDate={startDate}
          gridRowEndDay={endDate}
          overrideNumberofOutofBound={100}
          multipleDay={multipleDay}
        />
      )}
      <div
        id="calendarContainerScroll"
        ref={containerRef}
        className={classnames("w-100 flex-1", classes.gridContainer)}
      >
        <div className="d-flex w-100">
          <CalendarHourList
            loading={loading}
            outofBoundItems={outOfGridItems?.length}
          />
          <ContentGrid
            workWeek={workWeek}
            holidayData={holidayData}
            containerRef={containerRef}
            settings={settings}
            items={items}
            startDateMil={startDateMil}
          />
        </div>
      </div>
    </div>
  );
};

const InnerCalendarView = ({
  dateInfo,
  settings,
  holidayData,
  multipleDay,
  data,
  workWeek,
  loading,
}) => {
  const { startDateMil, startDate, endDate } = dateInfo;

  const { schema } = settings;
  const connectedResults = useMultipleEntityValueSelector(
    schema,
    data,
    selector,
  );

  const items = useWeekGridItems(
    connectedResults,
    startDate,
    settings,
    multipleDay,
  );

  const location = useLocation();
  const isOnCalendar = useMemo(() => {
    return location.pathname.includes("/calendar");
  }, [location.pathname]);

  const { outOfGridItems } = items;
  // console.log(items, data);
  const containerRef = useRef();

  return (
    <div
      className={classnames(
        "flex-1 w-100 d-flex flex-column position-relative rounded border-top-0",
        classes.weekView,
      )}
    >
      <IntermediaryBarLoader loading={loading} />
      <WeekDayHeader
        multipleDay={multipleDay}
        startMil={startDateMil}
        workWeek={workWeek}
        items={settings?.showTotalTime ? items : undefined}
        holidayData={holidayData}
      />
      {outOfGridItems && outOfGridItems.length > 0 && (
        <ItemsHeader
          outOfGridItems={outOfGridItems}
          startDate={startDate}
          settings={settings}
          multipleDay={multipleDay}
          gridRowEndDay={endDate}
          overrideNumberofOutofBound={isOnCalendar ? 100 : undefined}
        />
      )}
      <div
        id="calendarContainerScroll"
        ref={containerRef}
        className={classnames("w-100 flex-1", classes.gridContainer)}
      >
        <div className="d-flex w-100">
          <CalendarHourList
            loading={loading}
            outofBoundItems={outOfGridItems?.length}
          />
          <ContentGrid
            holidayData={holidayData}
            containerRef={containerRef}
            settings={settings}
            workWeek={workWeek}
            items={items}
            startDateMil={startDateMil}
          />
        </div>
      </div>
    </div>
  );
};

const CalendarWeekView = ({
  selectedDate,
  settings,
  workWeek,
  multipleDay,
}) => {
  const refetchRef = useReftchRefProvider();

  const dateInfo = useMemo(() => {
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();
    const day = selectedDate.getDate();
    if (multipleDay) return getMultipleDays(year, month, day);
    return getAllWeekDays(year, month, day);
  }, [multipleDay, selectedDate]);

  const url = useCalendarDateUrl(dateInfo, settings);

  const { schema, isAgendaTask, mutateRequest } = settings;
  const RSchema = useMemo(() => {
    return {
      d: {
        results: many(schema),
      },
      results: many(schema),
    };
  }, [schema]);

  const holidaysUrl = useMemo(() => {
    if (!dateInfo) return null;
    const startDateString = moment(dateInfo.startDate).format("YYYY-MM-DD");
    const endDateString = moment(dateInfo.endDate).format("YYYY-MM-DD");
    return `interventions/report?fromdate=${startDateString}&todate=${endDateString}`;
  }, [dateInfo]);

  const createToast = useToast();
  const [data, setData] = useState([]);

  const {
    data: holidayData,
    loading: loadingHolidays,
    refetch: refetchHolidays,
  } = useSpaceQuery(holidaysUrl, null);

  useEffect(() => {
    const { communicator } = settings;

    if (!communicator) return;

    const unsub = communicator.subscribe((e) => {
      const { type, id } = e;
      if (type !== "creation") return;
      setData((d) => [...d, id]);
    });
    return unsub;
  }, [settings]);

  const { loading, refetch } = useQuery(url, RSchema, {
    mutateBeforeNormalization: mutateRequest ? mutateRequest : undefined,
    onSuccess: ({ data }) => {
      if (data?.results?.Appointments || data?.results?.Times) {
        setData(() => {
          const resolvedApp = Array.isArray(data?.results?.Appointments)
            ? data?.results?.Appointments
            : [];
          const resolvedTimes = Array.isArray(data?.results?.Times)
            ? data?.results?.Times
            : [];
          return {
            appointments: resolvedApp,
            times: resolvedTimes,
          };
        });
      } else {
        if (data?.d?.results) setData(data.d.results);
        else setData(data.results);
      }
    },
    onError: () => {
      createToast({
        pos: "tm",
        type: "danger",
        description: <FormattedMessage id="CALENDAR_GENERAL_ERROR" />,
        title: <FormattedMessage id="ERROR" />,
      });
    },
    cache: false,
  });

  useEffect(() => {
    refetchRef.current = refetch;
  }, [refetch, refetchRef]);

  return (
    <UpdatingItemsProvider workWeek={workWeek}>
      {settings.all ? (
        <InnerCalendarViewAgenda
          workWeek={workWeek}
          multipleDay={multipleDay}
          loading={loading || loadingHolidays}
          holidayData={holidayData}
          settings={settings}
          data={data}
          dateInfo={dateInfo}
        />
      ) : (
        <InnerCalendarView
          workWeek={workWeek}
          multipleDay={multipleDay}
          loading={loading || loadingHolidays}
          holidayData={holidayData}
          settings={settings}
          data={data}
          dateInfo={dateInfo}
        />
      )}
    </UpdatingItemsProvider>
  );
};

export const AgendaWeekView = ({
  selectedDate,
  settings,
  workWeek,
  multipleDay,
}) => {
  const refetchRef = useReftchRefProvider();

  const notesRefetchRef = useRef(null);
  const interventionRef = useRef(null);
  const outlookEventsRef = useRef(null);
  const tarefasRef = useRef(null);
  const holidayRef = useRef(null);
  const selectedUser = useContext(AgendaSelectedUserContext);

  const dateInfo = useMemo(() => {
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();
    const day = selectedDate.getDate();
    if (multipleDay) return getMultipleDays(year, month, day);
    return getAllWeekDays(year, month, day);
  }, [multipleDay, selectedDate]);

  const notesUrl = useAgendaNotesDateUrl(dateInfo, settings);

  const TimeSettings = useMemo(() => {
    return {
      ...settings.extraTimeChargeSettings,
      extraInbuiltFilter: [
        {
          operator: "eq",
          field: "Account/Id",
          value: selectedUser,
          data: {
            type: "string",
          },
        },
      ],
    };
  }, [selectedUser, settings.extraTimeChargeSettings]);

  const timesUrl = useCalendarDateUrl(dateInfo, TimeSettings);

  const { schema, extraTimeChargeSettings } = settings;

  const Noteschema = useMemo(() => {
    return {
      d: {
        results: many(schema),
      },
      results: many(schema),
    };
  }, [schema]);

  const OutlookEventsSchema = useMemo(() => {
    return {
      d: {
        results: many(spaceOutlookEventsSchema),
      },
      results: many(spaceOutlookEventsSchema),
    };
  }, []);

  const Interventionschema = useMemo(() => {
    return {
      d: {
        results: many(extraTimeChargeSettings.schema),
      },
      results: many(extraTimeChargeSettings.schema),
    };
  }, [extraTimeChargeSettings]);

  const holidaysUrl = useMemo(() => {
    if (!dateInfo) return null;
    const startDateString = moment(dateInfo.startDate).format("YYYY-MM-DD");
    const endDateString = moment(dateInfo.endDate).format("YYYY-MM-DD");
    return `interventions/report?fromdate=${startDateString}&todate=${endDateString}`;
  }, [dateInfo]);

  const createToast = useToast();
  const [data, setData] = useState([]);

  const {
    data: holidayData,
    loading: loadingHolidays,
    refetch: refetchHolidays,
  } = useSpaceQuery(holidaysUrl, null);

  useEffect(() => {
    const { communicator } = settings;

    if (!communicator) return;

    const unsub = communicator.subscribe((e) => {
      const { type, id } = e;
      if (type !== "creation") return;
      setData((d) => [...d, id]);
    });
    return unsub;
  }, [settings]);

  const { loading, refetch: refetchNotes } = useQuery(notesUrl, Noteschema, {
    onSuccess: ({ data }) => {
      if (data.results) {
        setData((old) => {
          const resolvedApp = Array.isArray(data.results) ? data.results : [];
          return {
            ...old,
            appointments: resolvedApp,
          };
        });
      }
    },
    onError: () => {
      setData((old) => {
        // const resolvedApp = Array.isArray(data.results) ? data.results : [];
        return {
          ...old,
          appointments: [],
        };
      });
      createToast({
        pos: "tm",
        type: "danger",
        description: <FormattedMessage id="CALENDAR_GENERAL_ERROR" />,
        title: <FormattedMessage id="ERROR" />,
      });
    },
    cache: false,
  });

  const { loading: loadingTimes, refetch: refetchTimes } = useQuery(
    timesUrl,
    Interventionschema,
    {
      onSuccess: ({ data }) => {
        if (data?.d?.results) {
          setData((old) => {
            const resolvedApp = Array.isArray(data.d.results)
              ? data.d.results
              : [];
            return {
              ...old,
              times: resolvedApp,
            };
          });
        }
      },
      onError: () => {
        setData((old) => {
          return {
            ...old,
            times: [],
          };
        });
        createToast({
          pos: "tm",
          type: "danger",
          description: <FormattedMessage id="CALENDAR_GENERAL_ERROR" />,
          title: <FormattedMessage id="ERROR" />,
        });
      },
      cache: false,
    },
  );

  const outlookEventsUrl = useOutlookEventsDateUrl(dateInfo, {
    schema: spaceOutlookEventsSchema,
  });

  //Temp Job

  const { loading: loadingOutlookEvents, refetch: refetchOutlookEvents } =
    useQuery(
      // notesUrl, Noteschema,
      // notesUrl,
      outlookEventsUrl,
      OutlookEventsSchema,
      {
        mutateBeforeNormalization: outlookMutateBeforeNormalization,
        onSuccess: ({ data }) => {
          if (data?.results) {
            setData((old) => {
              const resolvedApp = Array.isArray(data?.results)
                ? data?.results
                : [];

              return {
                ...old,
                outlookEvents: resolvedApp,
              };
            });
          }
        },
        onError: () => {
          setData((old) => {
            return {
              ...old,
              outlookEvents: [],
            };
          });
          createToast({
            pos: "tm",
            type: "danger",
            description: <FormattedMessage id="CALENDAR_GENERAL_ERROR" />,
            title: <FormattedMessage id="ERROR" />,
          });
        },
        cache: false,
      },
    );

  const TarefasSchemas = useMemo(() => {
    return many(spaceTasksSchema);
  }, []);

  const tarefasUrl = useTarefasDateUrl(dateInfo);

  const { loading: loadingTaskEvents, refetch: refetchTaskEvents } = useQuery(
    tarefasUrl,
    TarefasSchemas,
    {
      mutateBeforeNormalization: (d) => {
        if (Array.isArray(d)) {
          return d.map((item) => {
            return {
              ...item,
              IsTask: true,
            };
          });
        } else return d;
      },
      onSuccess: ({ data }) => {
        if (Array.isArray(data)) {
          setData((old) => {
            return {
              ...old,
              tasks: data,
            };
          });
        }
      },
      onError: () => {
        setData((old) => {
          return {
            ...old,
            tasks: [],
          };
        });
        createToast({
          pos: "tm",
          type: "danger",
          description: <FormattedMessage id="CALENDAR_GENERAL_ERROR" />,
          title: <FormattedMessage id="ERROR" />,
        });
      },
      cache: false,
    },
  );

  useEffect(() => {
    interventionRef.current = refetchTimes;
    notesRefetchRef.current = refetchNotes;
    outlookEventsRef.current = refetchOutlookEvents;
    tarefasRef.current = refetchTaskEvents;
    holidayRef.current = refetchHolidays;
    refetchRef.current = () => {
      interventionRef.current();
      notesRefetchRef.current();
      outlookEventsRef.current();
      tarefasRef.current();
      holidayRef.current();
    };
  }, [
    refetchTimes,
    refetchNotes,
    refetchRef,
    refetchOutlookEvents,
    tarefasRef,
    refetchTaskEvents,
    refetchHolidays,
  ]);

  return (
    <UpdatingItemsProvider workWeek={workWeek}>
      {schema.name === "SpaceAgenda" ? (
        <InnerCalendarViewAgenda
          workWeek={workWeek}
          multipleDay={multipleDay}
          loading={
            loading ||
            loadingHolidays ||
            loadingTimes ||
            loadingOutlookEvents ||
            loadingTaskEvents
          }
          holidayData={holidayData}
          // loading={false}
          settings={settings}
          data={data}
          dateInfo={dateInfo}
        />
      ) : (
        <InnerCalendarView
          workWeek={workWeek}
          multipleDay={multipleDay}
          loading={
            loading ||
            loadingHolidays ||
            loadingTimes ||
            loadingOutlookEvents ||
            loadingTaskEvents
          }
          holidayData={holidayData}
          // loading={false}
          settings={settings}
          data={data}
          dateInfo={dateInfo}
        />
      )}
    </UpdatingItemsProvider>
  );
};

export default CalendarWeekView;
